import marketingInstance from '../instance'

const getIsValidGiftCoupon = (codeId) => {
  return marketingInstance.get(`/giftCoupons/code/${codeId}`)
}

export default getIsValidGiftCoupon
